import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Group } from 'components/core/Page';
import { H3, Link } from 'components/atoms';
import { Text } from 'components/atoms/Typography';
import { ensureAbsoluteUrl } from 'utils/format';

import './Cities.scss';

export function Cities({ title, cities, baseUrl }) {
	const base = baseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
	return (
		<Group className="nearby-locations">
			<H3
				className="title nearby-cities-title"
				size="medium"
				weight="ultraBold"
			>
				{title}
			</H3>
			<ul className="nearby-cities-links">
				{Children.toArray(
					cities.map(({ slug, name, rel }) => (
						<li className="nearby-city">
							<Link
								href={ensureAbsoluteUrl(slug, base)}
								rel={rel}
							>
								<Text
									size="standard"
									weight="ultraBold"
								>
									{name}
								</Text>
							</Link>
						</li>
					))
				)}
			</ul>
		</Group>
	);
}

Cities.propTypes = {
	title: PropTypes.string.isRequired,
	cities: PropTypes.arrayOf(PropTypes.object).isRequired,
	baseUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({
	baseUrl: state.app?.baseUrl,
});

export default connect(mapStateToProps)(Cities);